
<div *ngIf="loginBackground"
  class="d-flex flex-column flex-root h-100"
  id="kt_login_wrapper"
  [ngStyle]="{
    'background-image': 'url(' + loginBackground + '?v=1.2)',
    'background-repeat': 'no-repeat',
    'background-position': 'top left',
    'background-size': 'contain'
  }"
>
  <!--begin::Login-->
  <div class="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid" id="kt_login">
    <!--begin::Aside-->
    <div class="login-aside d-flex flex-column flex-row-auto">
      <!--begin::Aside Top-->
      <div class="d-flex flex-column-auto flex-column pt-lg-40 pt-15" style="padding-top: 250px">
        <!--begin::Aside header-->
        <a href="#" class="text-center mb-10">
          <!--<img src="./assets/image/invivo.png" class="" alt="" style="max-width: 600px;" />-->
          <!--<img src="./assets/image/christmas.jpg" class="" alt=""  />-->
        </a>
        <!--end::Aside header-->

        <!--begin::Aside title-->
        <!--<h3 class="font-weight-bolder text-center font-size-h4 font-size-h1-lg" style="color: #986923;">
          Chuyên nghiệp, minh bạch, hiệu quả <br/>
        </h3>-->
        <!--end::Aside title-->
      </div>
      <!--end::Aside Top-->

      <!--begin::Aside Bottom-->
      <!--<div class="aside-img d-flex flex-row-fluid bgi-no-repeat bgi-position-y-bottom bgi-position-x-center"
        style="background-image: url('./assets/image/kg2.png');background-size: contain"></div>-->
      <!--end::Aside Bottom-->
    </div>
    <!--begin::Aside-->

    <!--begin::Content-->
    <div style="background: rgb(255 255 255 / 0.8);"
         class="login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto">
      <!--begin::Content body-->
      <div class="d-flex flex-column-fluid flex-center">
        <router-outlet></router-outlet>
      </div>
      <!--end::Content body-->

      <!--begin::Content footer-->
      <!--<div class="d-flex justify-content-lg-start justify-content-center align-items-end py-7 py-lg-0">
        <a href="#" class="text-primary font-weight-bolder font-size-h5">Terms</a>
        <a href="#" class="text-primary ml-10 font-weight-bolder font-size-h5">Plans</a>
        <a href="#" class="text-primary ml-10 font-weight-bolder font-size-h5">Contact Us</a>
      </div>-->
      <!--end::Content footer-->
    </div>
    <!--end::Content-->
  </div>
  <!--end::Login-->
</div>
